import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const SummaryTandC = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Changes to Terms</h3>
      <p>
        We may update these Terms & Conditions from time to time to reflect
        changes in our services, legal requirements, or business practices. Any
        updates will be posted on this page with the date of the last revision.
      </p>
      <p>
        For significant changes, we may notify you via email or by displaying a
        prominent notice on our platform. We encourage you to review these Terms
        & Conditions periodically to stay informed about your rights and
        obligations.
      </p>
      <p>
        Changes will take effect immediately upon posting unless otherwise
        specified. Your continued use of the platform after any updates
        constitutes your acceptance of the revised Terms & Conditions.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default SummaryTandC;
